<template>
    <div>
        <smallbutton @click="Start()" toplabel="Manage Types" :class="buttonclass"/>
        <!-- ACCT NOTE MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="myform">
                    <label class="titlelabel">{{updateText}}</label>
                    
                    <div class="horizFlexCenter" >
                        
                            <input class="entryCheckbox" type="checkbox" v-model="includeInactive" >
                            <label class="entryLabel" for="">Include Inactive</label>
                 
                    </div>
                   
                    <div class="horizFlexCenter">
                        <updateseatingtype :showButton="trueParam" :isAdd="trueParam" :typeName="typeName" @save="savetype"/>
                        <updateseatingtype   :showButton="trueParam" :inType="selectedItem" :typeName="typeName" :disabled="selectedItem.id==0" @save="savetype"/>
                        <smallbutton :toplabel="EnableDisableButtonText" :disabled="selectedItem.id==0" @click="activateDeactivate()"/>
                    </div>
                    

                    <div class="resultsdiv" v-if="typeList.length>0">
                        <div v-for="result in filteredList" :key="result.id" :value="result.id" >
                            <lookupresult_nocols :topLeft="formattedName(result)"    @click="select(result)"
                                :selected="result.id==selectedItem.id" :inactive="!result.isActive">
                            
                            </lookupresult_nocols>  
                        </div>
                    </div>

                    <smallbutton  @click="close" toplabel="Close"/>
              </form>
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>

    import format from '../../format.js'
    import smallbutton from '../controls/button.vue'
    import actionmodal from './actionmodal.vue'
    import updateseatingtype from './updateseatingtype.vue'
    import lookupresult_nocols from '../controls/lookupresult_nocols.vue'

    export default {
        name:'seatingtypeadmin',
        components:{
            smallbutton,
            actionmodal,
            updateseatingtype,
            lookupresult_nocols
        },
        props:{
            typeName:{
                type:String,
                required:true
            },
            buttonclass:{
                type:String,
                default:'updatebutton'
            },
            typeList:{
                type:Array,
                required:true
            }
    
        },
        mixins:[format],
        data(){
            return{
                includeInactive:false,
                selectedItem:{
                    id:0,
                    name:null,
                    isActive:false
                },
                trueParam:true
            }
        },
        computed:{
            updateText(){
                return "Manage " + this.typeName
            },
            EnableDisableButtonText(){
                if(this.selectedItem.isActive){return "Deactivate"}
                else{return "Activate"}
            },
            filteredList(){
                if(this.includeInactive){
                    return this.typeList
                }else{
                    var filtered =[]

                    this.typeList.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let t=arr[index]
                        if(t.isActive ){
                            filtered.push(t)
                        }
                    } 
                    return filtered
                }
            }
           
        },
        methods:{
           formattedName(result){
            return result.name + ' (' + result.seatsAvailable + ')'
           },
           Start(){
            this.$refs.mymodal.openModal()
           },
           select(result){
              this.selectedItem=result
           },
   
            activateDeactivate(){
                this.selectedItem.isActive=!this.selectedItem.isActive
                this.$emit('save',this.selectedItem)
            },
            savetype(thistype){
                this.$emit('save',thistype)
            },
            
            close(){
                this.$emit('refresh')
                this.$refs.mymodal.closeModal()
            }
        }
    }
    </script>
    
    <style>

    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    